import { render, staticRenderFns } from "./FbIconSvg.vue?vue&type=template&id=18a0d3e0&"
import script from "./FbIconSvg.vue?vue&type=script&lang=js&"
export * from "./FbIconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports